import { useState, useEffect } from "react";
import StringToKebab from "../../helpers/StringToKebab";
import StyledButton from "../../atom/Button";
import styled from "styled-components";
import Breakpoints from "../../config/Breakpoints";
import { PromoEndDateFormat } from "../../helpers/LuckyNumberFormatUtil";

const CoverTagContainer = styled.div`
    padding: 1rem 2rem;
    border-radius: .5rem;
    display: flex;
    align-items: center;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.10);
    position: absolute;
    bottom: 2rem;
    left: 2rem;
    right: 2rem;
    background: var(--color-white);
    gap: .5rem;

    & > .message {
        flex: 1;
        font-size: var(--font-size-lg);
    }

    & > .buttons {
        display: flex;
        gap: .5rem;
    }

    @media ${Breakpoints.max.xs} {
        flex-direction: column;
        gap: .5rem;
        bottom: 1rem;
        left: 1rem;
        right: 1rem;
        padding: 1rem;

        & > .message {
            font-size: var(--font-size-md);
        }

        & > .buttons {
            flex: 1;
            width: 100%;
        }

        & > .buttons > .secondary {
            display: none;
        }

        & > .buttons > :not(.secondary) {
            flex: 1;
        }
    }
`;

const CoverTag = ({promoData, openAcceptAgreement, openLuckyNumbers}) => {
    const [dateInformation, setDateInformation ] = useState('');
    const [sectionToScroll, setSectionToScroll ] = useState(null);

    useEffect(() => {
        let dateInfo = PromoEndDateFormat(promoData.evaluateEndDate, promoData.daysToParticipate);
        setDateInformation(dateInfo);

        if(promoData.pageConfig?.sections?.length > 1) {
            setSectionToScroll(StringToKebab(promoData.pageConfig.sections[1].title));
        }
    },[promoData]);

    // const scrollToSection = (id) => {
    //     const sectionElement = document.getElementById(id);
    //     if(sectionElement) {
    //         sectionElement.scrollIntoView({behavior: 'smooth'});
    //     }
    // };

    return (
        <CoverTagContainer className="luckyNumber__coverDetails">
            <div className="message">
                {promoData.isEnded && <>Promoção encerrada</>}
                {!promoData.isEnded && !promoData.daysToParticipate && <>Participação encerrada</>}
                {!promoData.isEnded && promoData.daysToParticipate && <>Você tem até <strong>{dateInformation}</strong> para participar</>}
            </div>
            {!promoData.isEnded && (
                <div className="buttons">
                    {/* {sectionToScroll != null && (
                        <StyledButton onClick={() => scrollToSection(sectionToScroll)} className="secondary small" style={{borderRadius: ".5rem"}}>
                            Como participar
                        </StyledButton>
                    )}  */}
                    {promoData.agreement && promoData.daysToParticipate && !promoData.agreement?.isAccepted && (
                        <StyledButton className="small" style={{borderRadius: ".5rem"}} onClick={() => openAcceptAgreement()}>
                            Participar
                        </StyledButton>
                    )}
                    {promoData.agreement?.isAccepted && (
                        <StyledButton className="small" style={{borderRadius: ".5rem"}} onClick={() => openLuckyNumbers()}>
                            Meus números
                        </StyledButton>
                    )}
                </div>
            )}
        </CoverTagContainer>
    );
};

export default CoverTag;